import React from 'react';

function TermsOfService() {
  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-900 via-gray-900 to-purple-900">
      <main className="flex-grow py-20 pt-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-4xl font-extrabold text-white sm:text-5xl">
              Terms of Service
            </h2>
            <p className="mt-4 max-w-2xl text-lg text-gray-300 mx-auto">
              Effective Date: 01/01/2025
            </p>
          </div>
          <div className="bg-white bg-opacity-10 backdrop-filter backdrop-blur-lg shadow-lg rounded-lg p-6 sm:p-10 border border-white border-opacity-20">
            <div className="space-y-6 text-white">
              <section>
                <h3 className="text-2xl font-bold">1. Use of Service</h3>
                <p className="mt-2">
                  WLUMAPS is designed to help students of Wilfrid Laurier University find available classrooms and study spaces. By using our service, you agree to:
                </p>
                <ul className="mt-2 list-disc pl-5">
                  <li>Use the platform for its intended purpose only.</li>
                  <li>Comply with all applicable local, provincial, and federal laws.</li>
                </ul>
                <p className="mt-2">
                  You must not:
                </p>
                <ul className="mt-2 list-disc pl-5">
                  <li>Use the service to engage in unlawful, abusive, or disruptive activities.</li>
                  <li>Attempt to access or interfere with data, systems, or accounts not authorized for your use.</li>
                </ul>
              </section>
              <section>
                <h3 className="text-2xl font-bold">2. Third-Party Status</h3>
                <p className="mt-2">
                  WLUMAPS operates as an independent, third-party service. We are not affiliated with or endorsed by Wilfrid Laurier University. Any references to university buildings, spaces, or resources are for informational purposes only.
                </p>
              </section>
              <section>
                <h3 className="text-2xl font-bold">3. Service Availability</h3>
                <p className="mt-2">
                  WLUMAPS strives to provide accurate and up-to-date information about available study spaces. However:
                </p>
                <ul className="mt-2 list-disc pl-5">
                  <li>We do not guarantee the availability or accuracy of the information provided.</li>
                  <li>Services may be interrupted for maintenance, updates, or unforeseen technical issues.</li>
                  <li>WLUMAPS is not responsible for any inconvenience caused by the unavailability of study spaces or classrooms.</li>
                </ul>
              </section>
              <section>
                <h3 className="text-2xl font-bold">4. Intellectual Property</h3>
                <p className="mt-2">
                  All content on WLUMAPS, including images, text, logos, and software, is owned or licensed by WLUMAPS and is protected by copyright and other intellectual property laws. You may not:
                </p>
                <ul className="mt-2 list-disc pl-5">
                  <li>Reproduce, distribute, or modify any content without prior written consent.</li>
                  <li>Use WLUMAPS content for commercial purposes without authorization.</li>
                </ul>
              </section>
              <section>
                <h3 className="text-2xl font-bold">5. Limitation of Liability</h3>
                <p className="mt-2">
                  WLUMAPS is provided “as is” without warranties of any kind, either express or implied. To the fullest extent permitted by law:
                </p>
                <ul className="mt-2 list-disc pl-5">
                  <li>WLUMAPS is not responsible for any loss, damage, or inconvenience arising from your use of the service.</li>
                  <li>We do not guarantee the suitability of any study space or classroom listed on our platform.</li>
                </ul>
              </section>
              <section>
                <h3 className="text-2xl font-bold">6. User Responsibilities</h3>
                <p className="mt-2">
                  As a user of WLUMAPS, you agree to:
                </p>
                <ul className="mt-2 list-disc pl-5">
                  <li>Respect the rules and policies of Wilfrid Laurier University regarding classroom and study space usage.</li>
                  <li>Use the information provided responsibly and refrain from disrupting other users.</li>
                </ul>
              </section>
              <section>
                <h3 className="text-2xl font-bold">7. Changes to These Terms</h3>
                <p className="mt-2">
                  We may update these Terms of Service periodically to reflect changes in our practices or legal requirements. Changes will be communicated via our website. Continued use of WLUMAPS after changes constitutes acceptance of the updated terms.
                </p>
              </section>
              <section>
                <h3 className="text-2xl font-bold">8. Termination of Access</h3>
                <p className="mt-2">
                  We reserve the right to suspend or terminate access to WLUMAPS for users who violate these terms or engage in abusive, unlawful, or disruptive behavior.
                </p>
              </section>
              <section>
                <h3 className="text-2xl font-bold">9. Governing Law</h3>
                <p className="mt-2">
                  These Terms of Service are governed by the laws of Ontario, Canada. Any disputes will be resolved in the courts of Ontario.
                </p>
              </section>
              <section>
                <h3 className="text-2xl font-bold">10. Contact Us</h3>
                <p className="mt-2">
                  If you have questions or concerns about these Terms of Service, please contact us at:
                </p>
                <ul className="mt-2">
                  <li>Email: <a href="mailto:wlumap@gmail.com" className="text-blue-400 underline">wlumap@gmail.com</a></li>
                  <li>Website: <a href="https://wlumaps.com" className="text-blue-400 underline">https://wlumaps.com</a></li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default TermsOfService;